export const ANNUAL = 'annual';
export const QUARTERLY = 'quarterly';
